export const READ_USER_SETTINGS = '/user-settings/'
